<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-10">
            <div class="titulo">Configuração</div>
            <div class="subTitulo"> Faça aqui sua configurações. </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="borda"></div>
        </div>
      </div>
      <form action="">
        <b-form-group
          id="fieldset-1"
          label="Local de Aplicação"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="configuracao.frase_local_entrega"
            placeholder="Local de Aplicação"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="fieldset-1"
          label="Unidade de Recebimento das Embalagens"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            v-model="configuracao.frase_unidade_recebimento"
            placeholder="Unidade de Recebimento das Embalagens"
          >
          </b-form-input>
        </b-form-group>

        <b-form-group
          id="fieldset-1"
          description=""
          label="Responsável Técnico"
          label-for="input-3"
        >
          <v-select
            class="style-select"
            label="nome"
            :options="agronomos"
            :reduce="(item) => item.id_agronomo"
            v-model="configuracao.responsavel_tecnico"
            :dense="true"
            @input="$forceUpdate()"
          ></v-select>
        </b-form-group>

        <b-form-group
          id="fieldset-1"
          description=""
          label="Configurações adicionais"
          label-for="input-3"
        >
          <b-form-checkbox v-model="configuracao.gera_receita_xml" switch
            >Receituário XML</b-form-checkbox
          >
          <b-form-checkbox
            v-model="configuracao.baixa_estoque_receituario"
            switch
            >Receituário Baixa Estoque</b-form-checkbox
          >
          <b-form-checkbox
            v-model="configuracao.gera_receita_por_cultura"
            switch
            >Receituário por Cultura</b-form-checkbox
          >
        </b-form-group>
      </form>

      <div>
        <b-button variant="primary" @click="saveOrUpdate">Salvar</b-button>
      </div>
    </div>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </Layout>
</template>

<script>
import serviceAgronomo from '@/src/services/agronomo'
import serviceConfig from '@/src/services/api-receituario/configuracao'
import Layout from '@layouts/main'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  components: { Layout, Loading },
  data() {
    return {
      isLoading: false,
      formato: '',
      agronomos: [],
      configuracao: {},
    }
  },
  async mounted() {
    this.findConfig()
    this.findAgronomo()
  },

  methods: {
    findConfig() {
      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token
      serviceConfig
        .listar(token)
        .then((resposta) => {
          this.configuracao = resposta.data.configuracoes[0]
          console.log(this.configuracao)
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
        })
    },

    findAgronomo() {
      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token
      serviceAgronomo
        .listar(token)
        .then((resposta) => {
          this.agronomos = resposta.data.data
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
        })
    },

    saveOrUpdate() {
      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token

      if (this.configuracao.id) {
        serviceConfig
          .update(token, this.configuracao)
          .then((resposta) => {
            this.isLoading = false
            this.$bvToast.toast('Configuração atualizada!', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            window.localStorage.setItem(
              'configuracao',
              JSON.stringify(this.configuracao)
            )
          })
          .catch((erro) => {
            this.isLoading = false
            this.$bvToast.toast(erro.response.data.message, {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
          })
        return
      }
      serviceConfig
        .salvar(token, this.configuracao)
        .then((resposta) => {
          this.isLoading = false
          this.$bvToast.toast('Configuração salva!', {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          window.localStorage.setItem(
            'configuracao',
            JSON.stringify(this.configuracao)
          )
        })
        .catch((erro) => {
          this.isLoading = false
          this.$bvToast.toast(erro.response.data.message, {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
        })
    },
  },
}
</script>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;
  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .subtitulo {
    margin-bottom: 10px;
  }
  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }
  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;
    &.botaoTopo {
      float: right;
    }
  }
  .filterButton {
    background-color: #008e74c7;
    padding: 0 20px;
  }
  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>